import React from 'react';
import { Typography } from '@mui/material';
import GridContainer from 'components/shared/GridContainer';
import GridItem from 'components/shared/GridItem';
import Card from 'components/shared/Card';
import { IPCheckSession } from 'store/types/Meeting';
import { QuestionResponse } from 'store/enums/BallotReviewTypes';

interface IPCheckCompletionViewCardProps {
  ipCheckSession: IPCheckSession;
}

const IPCheckCompletionViewCard: React.FunctionComponent<IPCheckCompletionViewCardProps> = ({ ipCheckSession }) => {
  const completionConditionResult =
    ipCheckSession.completionConditionCheck === QuestionResponse.Yes
      ? `Sections 'Assessment of disclosed patented technologies' and 'LOA status check of PMPT' shall be completed and recorded for such patented technologies at next scheduled meeting of the TC Chapter. Until then this Letter Ballot Review is on hold.`
      : ipCheckSession.completionConditionCheck === QuestionResponse.No
      ? 'Go To Action'
      : undefined;

  return (
    <GridContainer>
      <GridItem>
        <Card title={<Typography variant="h6">IP check completion condition check</Typography>} bordered>
          <GridContainer spacing={1}>
            <GridItem md={12}>
              <Typography>
                <strong>
                  The co-chair checks if any Patented Technologies first become known to the TC Chapter on or after the
                  day of the issuance of this Letter Ballot:{' '}
                </strong>
                {ipCheckSession.completionConditionCheck ?? ''}
              </Typography>
            </GridItem>
            {completionConditionResult && (
              <GridItem md={12}>
                <Typography>
                  <strong>Result:</strong> {completionConditionResult}
                </Typography>
              </GridItem>
            )}
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default IPCheckCompletionViewCard;
